import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { useSelector } from 'react-redux';

import Checkbox from '../../common/Checkbox';
import { downloadDocument } from '../../../utils/exportHelper';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { dateInUTC } from '../../../utils/dateHelper';
import { PRODUCTS_FEEDS_DATETIME_FORMAT } from '../../../constants/dateFormats';

import styles from './ProductsFeedsTable.module.scss';

function getSuccessPercentage(row) {
  return (
    ((row.created_count + row.updated_count) / (row.created_count + row.updated_count + row.failed_count)) *
    100
  ).toFixed(2);
}

export function ProductsFeedRow({ row, checked, onChange, isEvenClassName }) {
  const { id: supplierId, name: supplierName } = useSelector((state) => state.role.supplier);
  const mixpanel = useMixpanel();
  const reportBi = (event) => {
    reportBusinessActionToMixpanel(mixpanel, event, { supplierName, supplierId });
  };

  const downloadReport = () => {
    downloadDocument(row.report_url);
    reportBi('product-feed-downloaded');
  };

  return (
    <tr key={row.batch_id} className={isEvenClassName}>
      <td>
        <Checkbox value={row.batch_id} hideLabel checked={checked} onChange={onChange} />
      </td>
      <td>{row.batch_id}</td>
      <td>{format(dateInUTC(row.started_at), PRODUCTS_FEEDS_DATETIME_FORMAT)}</td>
      <td>{format(dateInUTC(row.finished_at), PRODUCTS_FEEDS_DATETIME_FORMAT)}</td>
      <td>{row.created_count}</td>
      <td>{row.updated_count}</td>
      <td>{row.failed_count}</td>
      <td>{getSuccessPercentage(row)}%</td>
      <td>
        <div className={styles.actionsCell}>
          <button onClick={downloadReport}>Download</button>
        </div>
      </td>
    </tr>
  );
}

ProductsFeedRow.propTypes = {
  row: PropTypes.shape({
    batch_id: PropTypes.string.isRequired,
    started_at: PropTypes.string.isRequired,
    finished_at: PropTypes.string.isRequired,
    created_count: PropTypes.number,
    updated_count: PropTypes.number,
    failed_count: PropTypes.number,
    report_url: PropTypes.string,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isEvenClassName: PropTypes.string,
};
